import { commonMistakeCodes, passCodes } from '../passCodes';
import cipher37image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/37/image1.webp';
import track37 from '../../../../assets/audio/tracks/track37.mp3';

const hints = [
    {
        text: 'Koukněte se na tabulku vedle dveří.',
    },
    {
        text: 'Kódem je: muzeum',
        solution: true,
    },
];
export const step37graveyard = {
    id: 35,
    title: '17. stanoviště',
    taskText: `
        <p>
            Chudák, vždycky mi ho bylo strašně líto, že tady tak musí viset. Jinak je to totiž vážně milý chlapík, hezky se s ním povídá. Cože? Tak prý ani on neví, ale že koukal, a že už máme hodně indicií, abychom na to mohli přijít sami. 
        </p>
        <p>    
            Ještě ať se prej vydáme tady na Tvrz, že tam nad vchodem do té budovy, by mohlo být něco, co nám pomůže. Víc ale ani on neví. Jéé já vím, kde to je, to je tady kousek, dávají mi tam jídlo. Z toho stromu tam občas pozoruju lidi.
        </p>
    `,
    catImage: 7,
    audio: track37,
    snowAudio: track37,
    cipher: {
        label: 'Úkol',
        text: `
            <p>
                Místo kam máte jít hledejte v okruhu 200 metrů.
            </p>
            <p>
                Co se v budově, před kterou stojíte nachází?
            </p>
        `,
        images: [cipher37image1],
    },
    codeInputText: 'Zadejte kód',
    codeInputPassCodeRegexp: passCodes[27],
    codeInputPassCodeCommonMistakeRegexp: [commonMistakeCodes[3]],
    codeInputPassCodeCommonMistakeMessage: ['Tvrz je název ulice, hledejte dál co se v budově nachází.'],
    hints: hints,
    snowHints: hints,
};
